// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-cell_default__2ikca","fill":"idt-cell_fill__g4cw7","full":"idt-cell_full__2mohv","fit":"idt-cell_fit__3civb"};